module.exports = __webpack_public_path__ + "img/puppy-how-to-get.d7c2a253.webp";